import React from "react";

export default function Main({ children }) {
  return <div className="Main">{children}</div>;
}
